import React from 'react';

const SiteInactiveNotice = () => (
    <div
        className='flex flex-col items-center justify-center gap-1 py-16 text-center text-muted-foreground'
        data-testid='site-inactive-notice'
    >
        <p>This site has no data for the selected time period.</p>
        <p>Try selecting a different time period from the filter above.</p>
    </div>
);

export default SiteInactiveNotice;
